import {
  IColumn,
  ISumCategory,
} from '../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import { StandardColumnType } from '../PeriodOchKolumner/EditColumn/Components/Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import { ILocalAnalys } from '../../../EkonomiskAnalysMain/EkonomiskAnalysMain';
import {
  getDateInputType,
  hasAnyInterval,
} from '../../../../Utils/analysUtils';
import {
  IEkonomiskAnalysFilledDates,
  IEkonomiskAnalysDates,
} from '../../../AnalysSettingsHandler/AnalysSettingsHandler';
import {
  urvalFromKodplan,
  getEmptyUrval,
} from '../../../../../../../../../Components/Urval/Utils/urvalUtils';
import { AvenyCollectionMap } from '../../../../../../../../../Model/ModelContext/ModelContext';
import { kodplaner_ekkodplaner } from '../../../../../../../../../Components/KodplanManager/Queries/_QueryTypes/kodplaner';
import { clone } from 'ramda';
import { getUserString } from '../../../../../../../../../Utils/dateUtils';
import { ISelectedAnalys } from '../../../../EkonomiskAnalysPage';
import {
  defaultBudgetSummationMode,
  defaultSummationMode,
} from '../../../../Utils/SummationModeUtils';

export const NEW_ANALYS_RAPPORT_ID = 'create';
export const NEW_ANALYS_ID_KOD = 'NY_ANALYS';

export const setNewAnalys = (
  availableCategories: ISumCategory[],
  standardColumns: StandardColumnType[] | undefined,
  dates: IEkonomiskAnalysDates,
  avenyCollectionMap: AvenyCollectionMap,
  analys: ISelectedAnalys,
  createNewAnalys: (
    analys: ILocalAnalys,
    selectedAnalys: ISelectedAnalys
  ) => void,
  newAnalysColumns: IColumn[],
  activeKodplan?: kodplaner_ekkodplaner
) => {
  const newAnalys = getNewAnalys(
    availableCategories,
    standardColumns,
    dates,
    avenyCollectionMap,
    newAnalysColumns,
    activeKodplan
  );
  createNewAnalys(newAnalys, analys);
};

export const getNewAnalys = (
  availableCategories: ISumCategory[],
  standardColumns: StandardColumnType[] | undefined,
  dates: IEkonomiskAnalysDates,
  avenyCollectionMap: AvenyCollectionMap,
  newAnalysColumns: IColumn[],
  activeKodplan?: kodplaner_ekkodplaner
): ILocalAnalys => {
  const baskonto = availableCategories.find(x => x.code === 'ORDNINGS_NR_1');
  const baskontosum = baskonto
    ? baskonto.subCategories.find(x => x.code === 'KONTODEL_1')
    : undefined;
  // let newColumns: IColumn[] = [];
  // if (standardColumns) {
  // const includedValue = standardColumns.find(
  //   x => x.FALTKOD === 'PERINGVARDE'
  // );
  // const booked = standardColumns.find(x => x.FALTKOD === 'PERVARDE');
  // const outgoingValue = standardColumns.find(
  //   x => x.FALTKOD === 'PERUTGVARDE'
  // );
  // const columns = [
  //   getColumn(0, includedValue),
  //   getColumn(1, booked),
  //   getColumn(2, booked, 1),
  //   getColumn(3, booked, 2),
  //   getColumn(4, outgoingValue),
  // ];
  // newColumns = columns.filter(x => x !== undefined) as IColumn[];
  // }
  const newColumns: IColumn[] = newAnalysColumns;
  const newAnalys: ILocalAnalys = {
    loading: false,
    columns: newColumns,
    defaultSettings: {
      budgetSummationMode: defaultBudgetSummationMode,
      decimals: 2,
      denomination: 1,
      includeEjBokfordaJournaler: false,
      showComparison: true,
      summationMode: defaultSummationMode,
      exkluderaPersonalKostnader: false,
      visaSummeringar: true,
    },
    dateInputType: getDateInputType(newColumns, standardColumns),
    isInterval: hasAnyInterval(newColumns, standardColumns),
    category: 'Standard',
    categoryID: -102,
    title: 'Namnlös Analys',
    name: 'Namnlös Analys',
    sums: baskontosum ? baskontosum.sums : [],
    type: 'RAPPORTDIMENSIONLOPANDE',
    anvandsFor: [],
    // dates: fromFilledToUnfilledLocalAnalys(dates),
    dates: dates,
    expandToIndex: 0,
    urval: activeKodplan
      ? urvalFromKodplan(activeKodplan, avenyCollectionMap)
      : getEmptyUrval(),
    other: {
      budgetSummationMode: defaultBudgetSummationMode,
      includeEjBokfordaJournaler: false,
      denomination: 1,
      decimals: 2,
      showComparison: true,
      summationMode: defaultSummationMode,
      exkluderaPersonalKostnader: false,
      expandedSumIndex: 0,
    },
    sparatAnvandarUrval: null,
    lopsaldoDetaljrad: false,
    ai_prompt: null,
    detaljanalys: false,
    visaSummeringar: true,
  };

  return newAnalys;
};

export const fromFilledToUnfilledLocalAnalys = (
  dates: IEkonomiskAnalysFilledDates
): IEkonomiskAnalysDates => {
  const newDates = clone(dates);
  const { from, to } = dates;
  return {
    from: {
      ...newDates.from,
      userString: getUserString({
        year: from.year,
        month: from.month,
        day: from.day,
        userString: '',
      }),
    },
    to: {
      ...newDates.to,
      userString: getUserString({
        year: to.year,
        month: to.month,
        day: to.day,
        userString: '',
      }),
    },
  };
};

// const getColumn = (
//   id: number,
//   standardColumn?: StandardColumnType,
//   faltTyp?: number
// ): IColumn | undefined => {
//   if (!standardColumn) {
//     return undefined;
//   }
//   return {
//     name: standardColumn.BENAMNING || '',
//     id: id,
//     data: {
//       LOPNR: id,
//       ORDNINGS_NR: null,
//       FALTKOD: standardColumn.FALTKOD,
//       INTERN: null,
//       RESULTAT_TYP: null,
//       FALT_TYP: faltTyp ? faltTyp : null,
//       INTERVALL_TYP: 0,
//       BAS: '1',
//       ANTAL_DECIMALER: 0,
//       VAND_TECKEN: false,
//       BENAMNING: standardColumn.BENAMNING,
//       BENAMNING2: standardColumn.BENAMNING,
//       CODE_CAPTION: standardColumn.RUBRIK,
//       FROM_AR: 0,
//       FROM_AR_RELATIV: true,
//       TOM_AR: 0,
//       TOM_AR_RELATIV: true,
//       FROM_PER: 0,
//       FROM_PER_RELATIV: true,
//       TOM_PER: 0,
//       TOM_PER_RELATIV: true,
//       ENHET_ID: null,
//       CategoryPath: null,
//       Mallkolumn: false,
//       MallValidCategories: null,
//       RULLANDE: false,
//       RULLANDE_PERIOD_TYP: null,
//       RULLANDE_PERIOD_ANTAL: null,
//       BUDGETTYP: null,
//       BUDGETBENAMNING: null,
//       HIDE_COLUMN: false,
//       __typename: 'TEDAvenyEKAnalysColumn',
//     },
//   };
// };
